import { createFileRoute } from "@tanstack/react-router";

import Benchmark from "../pages/Benchmark";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/benchmark")({
  component: BenchmarkRoute,
});

function BenchmarkRoute() {
  return (
    <RequireAuth require="admin">
      <Benchmark />
    </RequireAuth>
  );
}
